import React, { Component, useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import { isActivityLowTech, getActivityLabelForValue } from './ConstActivityBtns';

const CURRENT_HELP = `
  <div>
    <p><strong>Purpose:</strong> The current access method just means whether the client has some type of access in place already, right now.  
    For example, a client may still be using an alternative mouse that they got 10 years ago for using their laptop, even though it’s not working as well for them as it once did.   
    Or in the low/no-tech case, a client may be trying to use a particular eye movement to indicate 'Yes'.</p>
    <p>Talking about any current access methods helps you and the client understand what problems need to be solved.  
    And the current access methods form a baseline that can be used for comparisons with any new access methods you decide to try. 
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  hasCurrentMethod: PropTypes.string,
  onChangeHasCurrentMethod: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  hasCurrentMethod: 'false',
};


//content sub-component with unique content for this page
class HistoryCurrentContent extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for whether client has a current access method (Yes or No).
  //Calls the setter that's passed in by the parent, when a radio button is clicked.
  //That setter changes the state of the hasCurrentMethod in the parent, 
  //which triggers a new render of the view with the new goal.

  render(){
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const priority = this.props.priority;
    const hasCurrentMethod = this.props.hasCurrentMethod;
    const onChangeHasCurrentMethod = this.props.onChangeHasCurrentMethod;

    let verb1 = "has";
    // let verb1not = "doesn't have";
    let verb2 = "uses";
    let verb3 = "practices";
    if (pronouns[0] === defaultProps.pronouns[0]){
      verb1 = "have";
      // verb1not = "do not have";  
      verb2 = "use";
      verb3 = "practice";
    }

    let yesLabel = `Yes, ${pronouns[0]} ${verb1} an access method that ${pronouns[0]} ${verb2} or ${verb3} with at least sometimes`;
    let noLabel = `No, there is nothing in place currently`;
    if (isActivityLowTech(priority)){
      yesLabel = `Yes, ${pronouns[0]} ${verb1} an access method for that activity`;
    }
  
    //set up button config as an object, then iterate to create markup
    // See https://programmingwithmosh.com/react/handling-form-react/ for starter code
    const radioBtns = [
      {
        value: 'true',
        label: yesLabel,
        moreInfo: ''
      },
      {
        value: 'false',
        label: noLabel,
        moreInfo: ''
      }
    ]
    
    return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        {radioBtns.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value}
              value={btn.value}
              checked={hasCurrentMethod===btn.value}
              onChange={onChangeHasCurrentMethod}
              name="has-current-method"
              type="radio"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
            </Label>
          </FormGroup>
        )}
      </FormGroup>
    </Form>
    </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoHistoryHasCurrent(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const priority = props.priority;
  const hasCurrentMethod = props.hasCurrentMethod;
  const onChangeHasCurrentMethod = props.onChangeHasCurrentMethod;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoHistoryHasCurrent");

  let verb2 = "uses";
  if (pronouns[0] === defaultProps.pronouns[0]){
    verb2 = "use";
  }

  let title = `Does ${firstName} currently have an access method that ${pronouns[0]} ${verb2}?`;
  let subTitle = "";
  if (isActivityLowTech(priority)){
    let activityLabel = getActivityLabelForValue(priority);
    title = `Does ${firstName} currently have any way to: ${activityLabel}?`;
    subTitle = "For example, for this low/no-tech activity, an access method might be eye movement that a partner can observe. Or it might be activating a switch in some way."
  }


  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",
    title: title,
    subTitle: subTitle,
    learnMore: {linkText: "Learn More about what we mean by a current access method and why it matters.",
                title: "Current Access Method",
                content: CURRENT_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  useEffect(() => {
    console.log('GIHHasCurrent mounted');
    return () => {
      console.log('GIHHasCurrent unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <HistoryCurrentContent 
          firstName={firstName} 
          pronouns={pronouns}
          priority={priority}
          hasCurrentMethod={hasCurrentMethod}
          onChangeHasCurrentMethod={onChangeHasCurrentMethod}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryHasCurrent.propTypes = propTypes;
GatherInfoHistoryHasCurrent.defaultProps = defaultProps;

export default GatherInfoHistoryHasCurrent;